import { render, staticRenderFns } from "./statement.vue?vue&type=template&id=ec239af2&scoped=true&"
import script from "./statement.vue?vue&type=script&lang=js&"
export * from "./statement.vue?vue&type=script&lang=js&"
import style0 from "./statement.vue?vue&type=style&index=0&id=ec239af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec239af2",
  null
  
)

export default component.exports